import { CommonError } from "lego-gui-lib";
import {
  RemoteChildDataSource,
  RemoteChildDataSourceOptions
} from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { RemoteListChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteListChildDataSource";
import { RemoteOneChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteOneChildDataSource";
import { action } from "mobx";
import { CalendarDto } from "../calendarView/CalendarMappers";

export class CalendarDayTypeDataSource<T, ID> extends RemoteChildDataSource<
  T,
  ID
> {
  public constructor(options: RemoteChildDataSourceOptions) {
    super(options);
    this.listDataSource = new CalendarDayTypeListDataSource<T, ID>(options);
    this.oneDataSource = new RemoteOneChildDataSource(options);
  }
}

export class CalendarDayTypeListDataSource<
  T,
  ID
> extends RemoteListChildDataSource<T, ID> {
  @action
  public async assignTypes(id: ID, dto: CalendarDto): Promise<any> {
    this.commons.setDataExchange();
    await this.lock.waitForUnlock();
    try {
      return await this.api.postMethod(
        this.url + "/" + this.schema.primaryKeyString(id) + "/assign",
        dto
      );
    } catch (e) {
      this.commons.newError(e.response.data as CommonError);
    } finally {
      this.commons.resetDataExchange();
    }
  }

  @action
  public async getTypeNamesWithDays(): Promise<any> {
    this.commons.setDataExchange();
    await this.lock.waitForUnlock();
    try {
      return await this.api.getMethod(this.url + "/withAssignedDays", {});
    } catch (e) {
      this.commons.newError(e.response.data as CommonError);
    } finally {
      this.commons.resetDataExchange();
    }
  }
}
